// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"255f0452","57":"c0f6cae2","98":"1d640c08","126":"1c1f8ef9","147":"a8a1bf2b","171":"6937adc0","252":"f9fbc13f","374":"cf95024e","466":"b29cc4f0","488":"ea1c37fe","507":"ff96d352","780":"3ac8b304"}[chunkId] + ".chunk.js";
};